import { useState, useEffect } from 'react';

/**
 * useDebouncedValue
 * Returns a debounced version of a value that only updates
 * after the given delay has passed without further changes.
 *
 * @param value - The input value to debounce.
 * @param delay - The debounce delay in milliseconds (default: 300).
 */
function useDebouncedValue(value, delay = 300) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

export { useDebouncedValue };
//# sourceMappingURL=useDebouncedValue.js.map
